import React from 'react';

const ClaimIdDxCell: React.FC<any> = (props) => {
  const isGroup = props.rowType === 'group';
  const value = isGroup ? (props.data.items[0] ? props.data.items[0].claimname : '') : props.data.claimname;
  return <span>{value}</span>;
};

export default ClaimIdDxCell;
